var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradingWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7438)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6794 17.1658C18.1889 17.1658 15.3594 19.9953 15.3594 23.4858V36.1258C15.3594 36.8441 15.6447 37.5331 16.1527 38.0411C16.6607 38.549 17.3496 38.8343 18.0679 38.8343H35.2222C35.9405 38.8343 36.6296 38.549 37.1376 38.0411C37.6455 37.5331 37.9308 36.8441 37.9308 36.1258V35.2229H33.4165C31.6713 35.2229 30.2565 33.8081 30.2565 32.0629V29.3543C30.2565 27.6091 31.6713 26.1943 33.4165 26.1943H37.9308V25.2915C37.9308 24.5731 37.6455 23.8842 37.1376 23.3762C36.6296 22.8683 35.9405 22.5829 35.2222 22.5829H22.5822C21.9589 22.5829 21.4537 22.0776 21.4537 21.4543C21.4537 20.831 21.9589 20.3258 22.5822 20.3258H34.3194V18.0686C34.3194 17.57 33.9151 17.1658 33.4165 17.1658H21.6794ZM33.4165 28.4515H39.7365C40.2351 28.4515 40.6394 28.8557 40.6394 29.3543V32.0629C40.6394 32.5615 40.2351 32.9658 39.7365 32.9658H33.4165C32.9179 32.9658 32.5137 32.5615 32.5137 32.0629V29.3543C32.5137 28.8557 32.9179 28.4515 33.4165 28.4515Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7438",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingWallet);
export default __webpack_public_path__ + "static/media/trading_wallet.d8631b600786553588f51b204ab52b11.svg";
export { ForwardRef as ReactComponent };